import { render, staticRenderFns } from "./QuestionSelectorTableModal.vue?vue&type=template&id=b2d8a566&scoped=true&"
import script from "./QuestionSelectorTableModal.vue?vue&type=script&lang=js&"
export * from "./QuestionSelectorTableModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelectorTableModal.vue?vue&type=style&index=0&id=b2d8a566&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d8a566",
  null
  
)

export default component.exports